import { __awaiter, __generator, __read } from "tslib";
import { Dialog, DialogBody, DialogSurface } from '@fluentui/react-components';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { applyUserSettingChange, CopilotFreStatus, getUserStorageOptions, setCopilotPinUserData, useCopilotFunnelLogging, } from '@office-start/copilot-fre-service';
import { useBCAIS, usePinningEligible, } from '@office-start/copilot-route-service';
import { copilotM365AppId, pinCopilotApp, useAppBarUserData, } from '@office-start/data-resolver-app-pinning';
import { useIdentity } from '@office-start/identity-service';
import { logError } from '@office-start/telemetry-service';
import React, { useCallback, useEffect } from 'react';
import { CopilotContinueFre } from './controls/CopilotContinueFre';
import { CopilotPinandContinueFre } from './controls/CopilotPinandContinueFre';
import { CopilotSkuContinueFre } from './controls/CopilotSkuContinueFre';
import { useStyles } from './CopilotFre.styles';
export function updatePinningSettings(newPinningStatus, context) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, applyUserSettingChange({
                        userPinningStatus: newPinningStatus,
                        userStorageOptions: getUserStorageOptions(context),
                    }).catch()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export var CopilotFre = function (_a) {
    var onCopilotFreCompleted = _a.onCopilotFreCompleted, userEntitlements = _a.userEntitlements, userPinningData = _a.userPinningData;
    var context = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var _b = __read(useCopilotFunnelLogging(), 1), logCopilotFunnelEvent = _b[0];
    var _c = __read(useAppBarUserData(), 2), userData = _c[0], setUserData = _c[1];
    var maxRetriesAllowed = 3;
    var styles = useStyles();
    var isBCAIS = useBCAIS();
    var isPinningEligible = usePinningEligible();
    var isCopilotAppPinned = userData === null || userData === void 0 ? void 0 : userData.pinnedApps.some(function (state) { return state.id === copilotM365AppId; });
    var pinAndAskMeLaterFREShow = useCallback(function (userEntitlements) {
        return (userEntitlements.userCopilotAdminSetting === 0 &&
            (userEntitlements.userCopilotUserSetting == null ||
                userEntitlements.userCopilotUserSetting == undefined) &&
            isPinningEligible &&
            !isCopilotAppPinned);
    }, [isCopilotAppPinned, isPinningEligible]);
    useEffect(function () {
        if (userEntitlements != null && identity != null) {
            if (pinAndAskMeLaterFREShow(userEntitlements)) {
                logCopilotFunnelEvent('OnCopilotPinAndContinueFreRender', {
                    IsOptinDialogShown: 'true',
                    IsOnboardingDialogShown: 'false',
                    PinAttempts: userPinningData.PinFREShowCount.toString(),
                });
            }
            else if (isBCAIS) {
                logCopilotFunnelEvent('OnCopilotM365ContinueFreRender', {
                    IsOptinDialogShown: 'false',
                    IsOnboardingDialogShown: 'true',
                    PinAttempts: userPinningData.PinFREShowCount.toString(),
                });
            }
            else {
                logCopilotFunnelEvent('OnCopilotContinueFreRender', {
                    IsOptinDialogShown: 'false',
                    IsOnboardingDialogShown: 'true',
                    PinAttempts: userPinningData.PinFREShowCount.toString(),
                });
            }
        }
    }, [
        identity,
        isBCAIS,
        logCopilotFunnelEvent,
        pinAndAskMeLaterFREShow,
        userEntitlements,
        userPinningData.PinFREShowCount,
    ]);
    function pinAndUpdatePinningSettings(newPinningStatus) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!context) return [3 /*break*/, 2];
                        return [4 /*yield*/, updatePinningSettings(newPinningStatus, context)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (newPinningStatus) {
                            pinCopilotApp(userData, setUserData);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    var updateRetryCount = function () {
        if (userPinningData.PinFREShowCount < maxRetriesAllowed) {
            userPinningData.PinFREShowCount += 1;
        }
    };
    var updateUserCopilotSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (!context) return [3 /*break*/, 2];
                    return [4 /*yield*/, setCopilotPinUserData(userPinningData, getUserStorageOptions(context))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    logError({
                        eventName: "CopiltotFre" /* KnownFeatureNames.CopilotFre */,
                        errorType: 'Copilot_Fre_Data_Error',
                        message: 'Failed to set user storage details for pinning copilot',
                        debugInfo: "Error for: setCopilotPinUserData-updateUserCopilotSettings info: ".concat(error_1),
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    function handleCopilotFreCompleted(response) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = response;
                        switch (_a) {
                            case CopilotFreStatus.Accepted: return [3 /*break*/, 1];
                            case CopilotFreStatus.Deferred: return [3 /*break*/, 3];
                            case CopilotFreStatus.Declined: return [3 /*break*/, 4];
                            case CopilotFreStatus.Continue: return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, pinAndUpdatePinningSettings(true)];
                    case 2:
                        _b.sent();
                        userPinningData.ShouldShowWelcomeFre = false;
                        return [3 /*break*/, 8];
                    case 3:
                        updateRetryCount();
                        return [3 /*break*/, 8];
                    case 4: return [4 /*yield*/, pinAndUpdatePinningSettings(false)];
                    case 5:
                        _b.sent();
                        userPinningData.ShouldShowWelcomeFre = false;
                        return [3 /*break*/, 8];
                    case 6:
                        userPinningData.ShouldShowWelcomeFre = false;
                        return [3 /*break*/, 8];
                    case 7: return [3 /*break*/, 8];
                    case 8:
                        userPinningData.CopilotFreStatus = response;
                        userPinningData.LastCopilotFreDisplayTimestamp =
                            new Date().toISOString();
                        return [4 /*yield*/, updateUserCopilotSettings()];
                    case 9:
                        _b.sent();
                        onCopilotFreCompleted(response);
                        return [2 /*return*/];
                }
            });
        });
    }
    var renderContent = function () {
        if (pinAndAskMeLaterFREShow(userEntitlements)) {
            return (React.createElement(CopilotPinandContinueFre, { onCopilotFreCompleted: handleCopilotFreCompleted, pinFREShowCount: userPinningData.PinFREShowCount }));
        }
        if (isBCAIS) {
            return (React.createElement(CopilotSkuContinueFre, { onCopilotFreCompleted: handleCopilotFreCompleted }));
        }
        return (React.createElement(CopilotContinueFre, { onCopilotFreCompleted: handleCopilotFreCompleted }));
    };
    return (React.createElement("div", { style: { zIndex: 1000001 } },
        React.createElement(Dialog, { open: true },
            React.createElement(DialogSurface, { className: styles.container },
                React.createElement(DialogBody, { className: styles.container }, renderContent())))));
};
//# sourceMappingURL=CopilotFre.js.map